import React, {useState,useEffect} from 'react'
import apiClient from '../api/apiClient'
import CreateTestGroupModal from '../components/CreateTestGroupModal'
import AddAssessorModal from '../components/AddAssessorModal'
import AddTeacherModal from '../components/AddTeacherModal'
import {useAuth} from '../context/AuthContext'
import './StaffPage.css'
import './TestGroupAdminPage.css'

export default function TestGroupAdminPage(){
    const {user} = useAuth()
    const schoolID = user.scId

    const [testGroups,setTestGroups] = useState([]);
    const [selectedTestGroup, setSelectedTestGroup] = useState(null)

    const [createTestGroupModal, setCreateTestGroupModal] = useState(false)
    const [addAssessorModal, setAddAssessorModal] = useState(false)
    const [addTeacherModal, setAddTeacherModal] = useState(false)
    
    const [searchTerm, setSearchTerm] = useState('')
    const [currentTestType, setCurrentTestType] = useState('ALLE')
    const [displayTestGroups, setDisplayTestGroups] = useState([])

    async function fetchTestGroups(){
        try{
            const result = await apiClient.get('/api/testgroup/getallwithnames', {
                params: {schoolID: schoolID}
            })
            setTestGroups(result.data)
            setDisplayTestGroups(result.data)
        }catch(e){
            console.log("error in fetching all test groups")
            console.log(e)
        }

    }

    useEffect(()=>{
        fetchTestGroups()
    },[createTestGroupModal, addTeacherModal, addAssessorModal])


    useEffect(()=>{
        const filteredTestGroupArray = testGroups.filter(tg => 
            {
                if(!(tg.studie === currentTestType || currentTestType ==='ALLE')) return false;
                const haystack = 
                (tg.navn+tg.studie+tg.eksaminator_initialer+tg.eksaminator_fornavn+tg.eksaminator_efternavn+
                tg.censor_fornavn+tg.censor_efternavn).toLowerCase()
                if(!haystack.includes(searchTerm.toLowerCase())) return false;
                return true;
            })    
        setDisplayTestGroups(filteredTestGroupArray)
    }, [currentTestType, searchTerm, testGroups])

    async function createTestGroup(formData){
        try{
            await apiClient.post('/api/testgroup/createtestgroup', formData)
            console.log("testgropu created")
            setCreateTestGroupModal(false)
        }catch(e){
            console.log("errer creating test group")
            console.log(e)
        }
    }

    async function addCensorToTestGroup(formData){
        try{
            await apiClient.post('/api/testgroup/addcensor', formData)
            console.log("censor added to skole " + schoolID)
            console.log("censor for pg "+ selectedTestGroup.id)
            setAddAssessorModal(false)
        }catch(e){
            console.log("error adding assessort")
            console.log(e)
        }
    }

    async function addTeacherToTestGroup(formData){
            console.log("BEFORE API, selectedTestGroup:", selectedTestGroup)

        try{
            await apiClient.post('/api/testgroup/addteacher', formData)
            //console.log("teacher added to school " + schoolID)
                        console.log("teacher for pg "+ selectedTestGroup.id)

            setAddTeacherModal(false)
        }catch(e){
            console.log("fejl ved at tilføje underviser til prøvegruppe")
            console.log(e)
        }
    }

    return(
        <div className="test-group-admin-page">
            <div className="table-card">
                <div className="table-bar">
                    <input 
                        type="text"
                        className="search-input"
                        placeholder="Søg..."
                        value={searchTerm}
                        onChange={(e)=>setSearchTerm(e.target.value)}
                        />
                        <select
                            value={currentTestType}
                            onChange={(e) =>setCurrentTestType(e.target.value)}
                            aria-label="Filtrér efter prøvetype"
                        >
                            <option key="ALLE" value="ALLE">Alle</option>
                            <option key="PD1" value="PD1">PD1</option>
                            <option key="PD2" value="PD2">PD2</option>
                            <option key="PD3" value="PD3">PD3</option>
                        </select>
                    <button
                        type="button"
                        className="action-btn"
                        onClick={()=>setCreateTestGroupModal(true)}
                        >
                        Opret prøvegruppe
                    </button>
                </div>
                <table className="censor-table">
                    <thead>
                        <tr>
                            <th>Navn</th>
                            <th>Prøvetype</th>
                            <th>Eksaminator</th>
                            <th>Censor</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {displayTestGroups.map(pg=>{
                        return(
                            <tr key={pg.id}>
                                <td>{pg.navn}</td><td>{pg.studie}</td>
                                <td>{pg.eksaminator_initialer && '('+pg.eksaminator_initialer+')'} {pg.eksaminator_fornavn} {pg.eksaminator_efternavn}</td>
                                <td>{pg.censor_fornavn} {pg.censor_efternavn}</td>
                                <td>
                                    <button
                                        type="button"
                                        className="tg-table-action"
                                        onClick={() =>{
                                        setSelectedTestGroup(pg)
                                        setAddTeacherModal(true)
                                    }}>
                                        Tilføj eksaminator
                                    </button>
                                    <button
                                        type="button"
                                        className="tg-table-action"
                                        onClick={() =>{
                                        setSelectedTestGroup(pg);
                                        setAddAssessorModal(true)
                                    }}>
                                    Tilføj censor
                                    </button>
                                </td>
                            </tr>
                        )                
                    })}    
                    </tbody>
                </table>
            </div>
            {createTestGroupModal &&
                <CreateTestGroupModal
                    schoolID = {schoolID}
                    onCreate ={createTestGroup}
                    onClose = {()=>setCreateTestGroupModal(false)}
                />
            }
            {addAssessorModal && (
                <AddAssessorModal 
                    schoolID = {schoolID}
                    testGroupID= {selectedTestGroup.id}
                    term_id = {selectedTestGroup.termin_id}
                    addCensor = {addCensorToTestGroup}
                    onClose ={() => setAddAssessorModal(false)}
                    />
            )}
            {addTeacherModal && (
                <AddTeacherModal
                    schoolID = {schoolID}
                    testGroupID = {selectedTestGroup.id}
                    term_id = {selectedTestGroup.termin_id}
                    addTeacher = {addTeacherToTestGroup}
                    onClose= {() => setAddTeacherModal(false)}
                />
            )}
        </div>
    )
}